module.exports = __webpack_public_path__ + "img/noimg.241e11c3.jpg";